import { render } from "./2HeroContent.vue?vue&type=template&id=521dcae3&scoped=true"
import script from "./2HeroContent.vue?vue&type=script&lang=js"
export * from "./2HeroContent.vue?vue&type=script&lang=js"

import "./2HeroContent.vue?vue&type=style&index=0&id=521dcae3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521dcae3"]])

export default __exports__